import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const TestimonialSlider = () => {
  const testimonials = [
    {
      id: 1,
      name: "Emma Johnson",
      designation: "Business Executive",
      text: "“Our stay at City Life Vacation Homes was an absolute dream! The apartment was beautifully furnished, and the service was exceptional. The location was perfect for both business and leisure.”",
      rating: 5,
      avatar: "/img/user.jpg",
    },
    {
      id: 2,
      name: "Michael Roberts",
      designation: "Travel Blogger",
      text: "“I have stayed at many places in Dubai, but City Life stands out for its luxury and attention to detail. The staff was incredibly helpful, and the villa we stayed in was spotless and perfectly located!”",
      rating: 5,
      avatar: "/img/user.jpg",
    },
    {
      id: 3,
      name: "Sara Bennett",
      designation: "Family Vacationer",
      text: "“This was our first time in Dubai, and City Life Vacation Homes made it so memorable. The family-friendly atmosphere, along with luxurious facilities, made our stay incredibly comfortable.”",
      rating: 5,
      avatar: "/img/user.jpg",
    },
  ];

  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 4000,
    slidesToShow: 2,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: "0px",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
          centerMode: false,
          autoplay: true,
          autoplaySpeed: 4000,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false,
          autoplay: true,
          autoplaySpeed: 4000,
        },
      },
    ],
  };

  return (
    <section
      className="space testimonial-style2 mb-5"
      style={{
        backgroundImage: "url(/assets/img/bg/testimonial-bg-2.jpg)",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="container">
        <div className="row">
          <div className="col-lg-6 col-md-6">
            <div className="title-area white-title">
              <span className="sec-subtitle">What Our Clients Say</span>
              <h2 className="sec-title h1">5,000+ Happy Guests Worldwide</h2>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-xl-12">
            <Slider {...settings}>
              {testimonials.map((testimonial) => (
                <div key={testimonial.id} className="p-2">
                  <div className="testi-style2">
                    <div className="testi-body">
                      <p className="testi-text">“{testimonial.text}”</p>
                      <div className="testi-rating">
                        {Array.from({ length: 5 }, (_, index) => (
                          <i
                            key={index}
                            className={`fas fa-star ${
                              index < testimonial.rating ? "filled" : ""
                            }`}
                          ></i>
                        ))}
                      </div>
                    </div>
                    <h3 className="testi-name">{testimonial.name}</h3>
                    <span className="testi-degi">
                      {testimonial.designation}
                    </span>
                    <div
                      className="testi-avater"
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <img src={testimonial.avatar} alt={testimonial.name} />
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialSlider;
